import { useState } from 'react';

import { formatPrice } from 'utils/helpers';
import { formatTimezoneSpecific } from 'utils/date';
import { TemplateList } from 'components/transactions-list';
import { useShowMore, handleMutation, useFetchByQueryId } from 'hooks';
import { EventCheckout, useLazyCheckoutInfoQuery } from 'store/api/event';

import { ExchangeDetails } from './details';
import { ExchangesListProps } from './types';
import { calculateDifferenceExchangeAndCheckoutItems } from './helpers';

const template = '1fr 2fr repeat(3, 1fr)';
const headers = [
  'Date',
  'Event Name',
  'Sale Total',
  'Return Amount',
  'Exchange Amount',
];

export const ExchangesList = ({
  data,
  hideShowMore,
  ...props
}: ExchangesListProps) => {
  const [selectedExchange, setSelectedExchange] = useState<EventCheckout>();
  const { visibleData, ...showMoreProps } = useShowMore(data);

  const [trigger, { ...detailsProps }] = useLazyCheckoutInfoQuery();
  handleMutation(detailsProps);

  const { setQueryId } = useFetchByQueryId<EventCheckout>({
    trigger,
    queryName: 'exchangeId',
    selectDetails: setSelectedExchange,
  });

  return (
    <>
      <TemplateList<EventCheckout>
        title="Exchanges"
        headers={headers}
        data={visibleData}
        template={template}
        hasMinHeight={false}
        tabletTemplate={template}
        maxHeight={visibleData?.length ? 350 : undefined}
        onClick={(e, value) => setSelectedExchange(value)}
        listProps={hideShowMore ? undefined : showMoreProps}
        render={(exchange) => [
          formatTimezoneSpecific(
            exchange.createdAt,
            exchange?.event?.timezone?.code
          ),
          exchange?.event?.name,
          formatPrice(exchange.saleTotal),
          formatPrice(exchange?.exchangeItemsAmount),
          formatPrice(calculateDifferenceExchangeAndCheckoutItems(exchange)),
        ]}
      />

      <ExchangeDetails
        {...props}
        data={selectedExchange}
        opened={!!selectedExchange}
        onClose={() => {
          setSelectedExchange(undefined);
          setQueryId('');
        }}
      />
    </>
  );
};
